// src/components/Reports/SendStudentReport.jsx
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { sendCustomReportToStudent } from '../../../../utils/reports';
import { ErrorMsg, success } from '../../../../utils/Toast';

function SendStudentReport({ studentId, classId }) {
  const { user } = useSelector((state) => state.loggedUser);
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    from: '',
    to: '',
    about: '',
  });

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSendReportToStudent = async () => {
    const { from, to, about } = formData;
    if (!from || !to || !about) {
      ErrorMsg('Please fill in all fields');
      return;
    }

    try {
      const res = await sendCustomReportToStudent(
        classId,
        studentId,
        from,
        to,
        about,
        user?._id
      );
      success(res.data?.message);
      handleClose();
    } catch (error) {
      ErrorMsg(error?.response?.data?.message || error?.message);
      console.error('Error sending report:', error);
    }
  };

  return (
    <div className="text-center mt-3">
      <Button variant="primary" onClick={handleShow}>
        Send Report
      </Button>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Send Report to Student</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>From</Form.Label>
              <Form.Control
                type="date"
                name="from"
                value={formData.from}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>To</Form.Label>
              <Form.Control
                type="date"
                name="to"
                value={formData.to}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>About</Form.Label>
              <Form.Select
                name="about"
                value={formData.about}
                onChange={handleChange}
              >
                <option value="">Select type</option>
                <option value="homework">Homework</option>
                <option value="attendance">Attendance</option>
                <option value="activity">Activity</option>
                <option value="mock">Mock</option>
                <option value="test">Test</option>
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleSendReportToStudent}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default SendStudentReport;
